module.exports = "/_next/static/images/d4c0bfc425b3a646f610e2dc63947fa6-apple-pay-lg.png";